import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle } from 'lucide-react';
export function DisclaimerSection() {
  return <section className="bg-navy-950 py-8 border-t border-navy-800 text-cream-100/50" data-id="element-39">
      <div className="container mx-auto px-4" data-id="element-40">
        <div className="max-w-[720px] mx-auto" data-id="element-41">
          <FadeIn data-id="element-42">
            <div className="flex items-start gap-3 text-sm" data-id="element-43">
              <AlertCircle className="shrink-0 mt-0.5 opacity-50" size={16} data-id="element-44" />
              <p className="leading-relaxed" data-id="element-45">
                <strong data-id="element-46">Aviso importante:</strong> Esta guía es puramente
                educativa e informativa. No constituye consejo médico,
                diagnóstico ni sustituye la evaluación o el tratamiento médico
                profesional. Si experimenta síntomas graves o tiene
                preocupaciones sobre su salud prostática, consulte siempre a un
                médico calificado.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}